import './App.css';
import { Route } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard/Dashboard';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Login } from './pages/Login/Login';
import { Toaster } from 'react-hot-toast';
import { AdminLogin } from './AdminPages/AdminLogin';
import { DashboardAdmin } from './AdminPages/DashboardAdmin/DashboardAdmin';
import { Superadmin } from './Superadmin/Superadmin';

export default function App() {
  return (
    <div className="App loginBackgroundImage">
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            borderRadius: '10px',
            background: '#333',
            color: '#fff',
          },
        }}
      />
      <Routes>
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard/*" element={<DashboardAdmin />} />
        <Route path="/superadmin/config" element={<Superadmin />} />
      </Routes>
    </div>
  );
}

